import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { injectIntl, defineMessages } from 'react-intl'
import { compose } from 'recompose'
import { roles } from '../../common/config'
import subjectsMessages from '../../common/translations/subjectsMessages'
import { loadSubjects } from '../../common/subjects/actions'
import { loadTags, loadTagsBySubject, loadTagsByLanguage } from '../../common/tags/actions'
import Tag from '../components/Tag'
import Button from '../components/Button'
import PageHeader from '../components/PageHeader'
import YoutubeVideo from '../components/YoutubeVideo'
import TextInput from '../components/fields/TextInput'
import SelectInput from '../components/fields/SelectInput'
import TextAreaInput from '../components/fields/TextAreaInput'


class LessonFormHeader extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      addMediumType: '',
      searchTag: '',
    }
  }

  componentDidMount() {
    const { subjects, loadSubjects, loadTagsByLanguage, tags,
      viewer, loadTagsBySubject } = this.props

    loadSubjects()
    
    if (viewer) {
      if (viewer.subjects && viewer.subjects.lenght) {
        loadTagsBySubject(viewer.subjects[0])
      } else if (viewer.foreignLanguage) {
        loadTagsByLanguage(viewer.foreignLanguage)
      }
    }
  }

  setActiveMediumType(addMediumType) {
    this.setState({ addMediumType })
  }

  render() {
    const { fields, isDetailPage, lesson, errors, viewer, instructions,
      intl, subjects, tags, loadTagsBySubject } = this.props
    const { addMediumType, searchTag } = this.state

    const hasVideo = !!fields.youtubeVideo.value
    const hasText = !!fields.prologueText.value

    return (
      <React.Fragment>
        {
          !isDetailPage &&
          <PageHeader
            title={lesson ?
              `${intl.formatMessage(messages.editexercise)} ${lesson.name}`
              : intl.formatMessage(messages.createexercise)}
            button={<Button positive type="submit" className="float-right disable-spacing-right">
              {intl.formatMessage(messages.save)}
            </Button>}
          />
        }
        {errors}
        <TextInput
          {...fields.name}
          label={intl.formatMessage(messages.name)}
          placeholder={intl.formatMessage(messages.enterName)}
          disabled={isDetailPage}
          className="lesson-name"
        />
        {
          viewer && viewer.role === roles.TEACHER &&
          <TextInput
            label={intl.formatMessage(messages.instructionsLabel)}
            disabled={isDetailPage}
            className="width-full lesson-instructions"
            placeholder={instructions || intl.formatMessage(messages.instructionsPlaceholder)}
            {...fields.instructions}
          />
        }
        <SelectInput
          {...fields.subject}
          disabled={isDetailPage}
          label={intl.formatMessage(messages.subject)}
          defaultValue={intl.formatMessage(messages.subjectLabel)}
          options={subjects.map(subject => ({
            ...subject,
            label: intl.formatMessage(subjectsMessages[subject.name]),
          }))}
          onChange={(e) => {
            const newValue = e.target.value
            loadTagsBySubject(newValue)
            fields.subject.onChange({ value: newValue })
          }}
        />
        {
          viewer && viewer.role === roles.TEACHER &&
          <div className="width-full">
            {
              !isDetailPage &&
              <React.Fragment>
                <TextInput
                  label={intl.formatMessage(messages.tagsLabel)}
                  disabled={isDetailPage}
                  placeholder={intl.formatMessage(messages.tagsPlaceholder)}
                  value={searchTag}
                  onChange={(e) => this.setState({ searchTag: e.target.value })}
                />
                <div className="width-full float-left">
                  {
                    tags.filter(tag => !fields.tags.value.find(t => t.id === tag.id))
                        .filter(tag => !searchTag || tag.name.startsWith(searchTag))
                        .map(tag => (
                          <Tag
                            key={tag.id}
                            tag={tag}
                            onClick={() => {
                              fields.tags.onChange({ value: [...fields.tags.value, tag] })
                              this.setState({ searchTag: '' })
                            }}
                          />
                    ))
                  }
                </div>
              </React.Fragment>
            }
            {
              fields.tags.value && !!fields.tags.value.length &&
              <div className="width-full float-left">
                <p className="bold-text small-spacing-bottom">
                  {intl.formatMessage(messages.tagsSelected)}
                </p>
                {fields.tags.value.map(tag => (
                  <Tag
                    key={tag.id}
                    tag={tag}
                    onClick={() => !isDetailPage ? fields.tags.onChange({
                      value: fields.tags.value.filter(t => tag.name !== t.name) }) : null}
                  />
                ))}
              </div>
            }
          </div>
        }

        <div className="lesson-options-row">
          {
            (hasText || hasVideo || !isDetailPage) &&
            <div className="media-content">
              {
                !isDetailPage &&
                <div className="media-content-picker">
                  <h3>{intl.formatMessage(messages.addToexercise)}</h3>
                  <div className="media-content-picker-options">
                    {
                      (viewer && viewer.role === roles.TEACHER) &&
                      <Button
                        className={hasText ? 'positive-button' : ''}
                        disabled={hasText}
                        onClick={() => this.setActiveMediumType('text')}
                      >
                        {intl.formatMessage(messages.initialText)}
                      </Button>
                    }
                    <Button
                      className={hasVideo ? 'positive-button' : ''}
                      disabled={hasVideo}
                      onClick={() => this.setActiveMediumType('youtube-video')}
                    >
                      {intl.formatMessage(messages.youtubeVideo)}
                    </Button>
                  </div>
                </div>
              }
              {
                (addMediumType === 'youtube-video' || hasVideo) &&
                <div className="flex-column youtube-video media-content-item">
                  <TextInput
                    label={intl.formatMessage(messages.youtubeVideo)}
                    disabled={isDetailPage}
                    placeholder={intl.formatMessage(messages.videoPlaceholder)}
                    className="width-full"
                    {...fields.youtubeVideo}
                  />
                  {
                    fields.youtubeVideo.value &&
                    <YoutubeVideo videoUrl={fields.youtubeVideo.value} />
                  }
                  {
                    !isDetailPage &&
                    <Button
                      className="negative-button disable-horizontal-spacing"
                      onClick={() => {
                        if (addMediumType === 'youtube-video') {
                          this.setActiveMediumType('')
                        }
                        fields.$setValue('youtubeVideo', '')
                      }}
                    >
                      {intl.formatMessage(messages.removeVideo)}
                    </Button>
                  }
                </div>
              }
              {
                (addMediumType === 'text' || hasText) &&
                <div className="flex-column media-content-item">
                  <TextAreaInput
                    label={intl.formatMessage(messages.textLabel)}
                    className="width-full"
                    placeholder={intl.formatMessage(messages.textPlaceholder)}
                    disabled={isDetailPage}
                    {...fields.prologueText}
                  />
                  {
                    !isDetailPage &&
                    <Button
                      className="negative-button disable-horizontal-spacing"
                      onClick={() => {
                        if (addMediumType === 'text') {
                          this.setActiveMediumType('')
                        }
                        fields.$setValue('text', '')
                      }}
                    >
                      {intl.formatMessage(messages.removeText)}
                    </Button>
                  }
                </div>
              }
            </div>
          }
        </div>
      </React.Fragment>
    )
  }
}

LessonFormHeader.defaultProps = {
  instructions: '',
  isDetailPage: false,
  lesson: null,
  errors: null,
  viewer: null,
  tags: [],
  subjects: [],
}

LessonFormHeader.propTypes = {
  viewer: PropTypes.object,
  intl: PropTypes.object.isRequired,
  fields: PropTypes.object.isRequired,
  loadTags: PropTypes.func.isRequired,
  loadTagsBySubject: PropTypes.func.isRequired,
  loadTagsByLanguage: PropTypes.func.isRequired,
  loadSubjects: PropTypes.func.isRequired,
  instructions: PropTypes.string,
  isDetailPage: PropTypes.bool,
  lesson: PropTypes.object,
  errors: PropTypes.any,
  tags: PropTypes.array,
  subjects: PropTypes.array,
}

const enhance = compose(
  connect(state => ({
    tags: state.tags.all,
    subjects: state.subjects.all,
    viewer: state.users.viewer,
  }), { loadTags, loadSubjects, loadTagsBySubject, loadTagsByLanguage }),
  injectIntl,
)

export default enhance(LessonFormHeader)

const messages = defineMessages({
  subject: {
    id: 'lesson.formHeader.subject',
    defaultMessage: 'Predmet',
  },
  editexercise: {
    id: 'lesson.formHeader.editexercise',
    defaultMessage: 'Upraviť cvičenie',
  },
  createexercise: {
    id: 'lesson.formHeader.createexercise',
    defaultMessage: 'Vytvoriť nové cvičenie',
  },
  save: {
    id: 'lesson.formHeader.save',
    defaultMessage: 'Uložiť',
  },
  name: {
    id: 'lesson.formHeader.name',
    defaultMessage: 'Názov cvičenia',
  },
  enterName: {
    id: 'lesson.formHeader.enterName',
    defaultMessage: 'Zadajte názov cvičenia',
  },
  instructionsLabel: {
    id: 'lesson.formHeader.instructionsLabel',
    defaultMessage: 'Inštrukcie (voliteľné)',
  },
  instructionsPlaceholder: {
    id: 'lesson.formHeader.instructionsPlaceholder',
    defaultMessage: 'Inštrukcie (voliteľné)',
  },
  tagsLabel: {
    id: 'lesson.formHeader.tagsLabel',
    defaultMessage: 'Tagy',
  },
  tagsPlaceholder: {
    id: 'lesson.formHeader.tagsPlaceholder',
    defaultMessage: 'Vyberte tagy',
  },
  tagsSelected: {
    id: 'lesson.formHeader.tagsSelected',
    defaultMessage: 'Vybrané tagy',
  },
  addToexercise: {
    id: 'lesson.formHeader.addToexercise',
    defaultMessage: 'Pridať k cvičeniu',
  },
  initialText: {
    id: 'lesson.formHeader.initialText',
    defaultMessage: 'Úvodný text',
  },
  youtubeVideo: {
    id: 'lesson.formHeader.youtubeVideo',
    defaultMessage: 'Youtube video',
  },
  videoPlaceholder: {
    id: 'lesson.formHeader.videoPlaceholder',
    defaultMessage: 'Zadajte url adresu youtube videa',
  },
  removeVideo: {
    id: 'lesson.formHeader.removeVideo',
    defaultMessage: 'Odobrať video',
  },
  removeText: {
    id: 'lesson.formHeader.removeText',
    defaultMessage: 'Odobrať text',
  },
  textLabel: {
    id: 'lesson.formHeader.textLabel',
    defaultMessage: 'Text ku cvičeniu',
  },
  textPlaceholder: {
    id: 'lesson.formHeader.textPlaceholder',
    defaultMessage: 'Zadajte sprievodný text ku cvičeniu',
  },
  subjectLabel: {
    id: 'lesson.formHeader.subjectLabel',
    defaultMessage: 'Vyberte predmet',
  },
})



// WEBPACK FOOTER //
// ./src/browser/forms/LessonFormHeader.js